<template>
  <v-container fluid tag="section">
    <div class="white rounded-lg my-2 pa-4">
      <v-row>
        <v-col cols="12" md='2' class="pr-2 pl-3 px-1">
          <base-marerial-user-select outlined dense label='用户选择' @on-change='statis' hide-details v-model="params.userIds" mid :menu='$constants.SysMenu.CONTRACT_M_ID'></base-marerial-user-select>
        </v-col>
        <v-col cols="12" md='2' class="pr-2 pl-0 px-1">
          <v-btn depressed dark :loading='loading' @click="statis" color="primary" class="mx-1 px-2">
            <v-icon size="20" dark>mdi-magnify</v-icon>查询
          </v-btn>
        </v-col>
      </v-row>
    </div>
    <v-row>
      <v-col cols="12">
        <v-card class="elevation-0 rounded-lg text-center" :loading='loading'>
          <v-card-title>{{beginYear}}年～{{Number(this.$moment().format('YYYY'))}}年各月签单额走势图</v-card-title>
          <v-card-text>
            <ve-line :data="chartData" :loading='loading' :extend='chartExtend' :settings="chartSettings" height='550px'></ve-line>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { selectData2 } from '@/utils/tool.js'
  import { month } from '@/api/statis/month.js'

  export default {
    name: 'StatisMonth',
    data() {
      this.chartSettings = {
        area: true
      }
      this.chartExtend = {
        tooltip: {
          textStyle: {
            align: 'left'
          }
        },
        yAxis: {
            type: 'value',
            name: '签单额(元)',
            axisTick: {
                inside: true
            },
            scale: true,
            axisLabel: {
              margin: 2,
              formatter: function (value) {
                if (value >= 10000 && value < 10000000) {
                    value = `${value / 10000}万`
                } else if (value >= 10000000) {
                    value = `${value / 10000000}千万`
                }
                return value;
              }
            },
        },
      }
      return {
        params: {
          year: Number(this.$moment().format('YYYY')),
          userIds: []
        },
        beginYear: 2020,
        chartData: {
          columns: ['月份'],
          rows: []
        },
        loading: false,
        result: {},
        yearItems: selectData2(),
      }
    },
    methods: {
      statis () {
        this.setColumns()
        this.loading = true
        month(this.params).then(res => {
          if (res.status === 200) {
            this.chartData.rows = res.data
          }
          this.loading = false
        })
      },
      setColumns () {
        this.chartData.columns = ['月份']
        const thisYear = Number(this.$moment().format('YYYY'))
        for (let i = 0; i < thisYear - this.beginYear + 1; i++) {
          this.chartData.columns.push(`${this.beginYear + i}年`)
        }
      }
    },
    created () {
      this.statis()
    }
  }
</script>
